import {Module} from 'vuex'
import {RootState} from '@/store/types'
import {Page, PageTranslation} from '@/modules/cms/types'
import mutations from '@/modules/cms/store/mutations'
import actions from '@/modules/cms/store/actions'
import menuModule from '@/modules/cms/modules/menu/store'
import galleryModule from '@/modules/cms/modules/gallery/store'
import moderationModule from '@/modules/cms/modules/moderation/store'
import store from '@/store';
import {setCurrentMetadata, setCurrentTranslation} from '@/modules/seo/store/subscriptions';

export interface CMSState {
    /**
     * Lista de todas las páginas registradas en el sitio web
     */
    pages: Page[]

    /**
     * La página que esta actualmente en edición o creación
     */
    currentPage: Page,

    /**
     * Almacena la traducción actual que se encuentra en edición
     */
    currentTranslation: PageTranslation,

    /**
     * Indica si esta en proceso la obtención de la lista de páginas del servidor
     */
    loadingPageList: boolean

    /**
     * Indica si esta en proceso la obtención de la lista de página del servidor
     */
    loadingPage: boolean

    /**
     * Indica que la aplicación esta guardando una página en el servidor
     */
    savingPage: boolean

    /**
     * Indica si el servidor esta sincronizando las páginas
     */
    syncPages: boolean

    /**
     * Almacena la página que el usuario desea eliminar
     */
    pageToDelete: Page

    /**
     * Indica si esta activa la pantalla para la vista previa de la página estática
     */
    pagePreview: boolean

    /**
     * Contenido de la página estática
     */
    pagePreviewContent: string

    /**
     * Indica si la aplicación esta generando la vista previa de la página estática
     */
    loadingPagePreview: boolean
}

// Registra dos listeners
store.listen('cms/page/current/set', setCurrentMetadata)
store.listen('cms/page/current/translation/set-by-locale', setCurrentTranslation)

/**
 * Módulo de Vuex
 *
 * @type {{state: {}}}
 */
const vuexModule: Module<CMSState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    // Sub-módulos del modulo CMS
    modules: {
        menu: menuModule,
        gallery: galleryModule,
        moderation: moderationModule,
    },
    state: {
        pages: [],
        currentPage: new Page(),
        currentTranslation: new PageTranslation(''),
        savingPage: false,
        syncPages: false,
        loadingPageList: false,
        loadingPage: false,
        pageToDelete: new Page(),
        pagePreview: false,
        pagePreviewContent: '',
        loadingPagePreview: false,
    },
}

export default vuexModule
